var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"relative w-full"},[(
          (!_vm.$route.path.includes('/login') && _vm.$route.path.name == 'Login') ||
            _vm.$route.path.includes('property_selection') ||
            _vm.$route.path.includes('home') ||
            _vm.$route.path.includes('customer-dashboard') ||
            _vm.$route.path.includes('admin-dashboard-screen') ||
            _vm.$route.path.includes('my-documents') ||
            _vm.$route.path.includes('submit-documents') ||
            _vm.$route.path.includes('book_appointment') ||
            _vm.$route.path.includes('request-documents')
        )?_c('Navbar',{staticClass:"text-white"}):_vm._e(),(_vm.$route.path.includes('/login/signup/bis'))?_c('NavbarSignup'):_vm._e(),_c('div',{staticClass:"md:flex"},[(
            _vm.$route.name == 'Moldex Buyers Guide' ||
              _vm.$route.name == 'buyers_guide_content' ||
              _vm.$route.name == 'FAQ' ||
              _vm.$route.path == '/home/my-documents' ||
              _vm.$route.path == '/home/request-documents' ||
              _vm.$route.path == '/home/book_appointment' ||
              _vm.$route.path == '/home/book_appointment/calendar' ||
              _vm.$route.path == '/home/book_appointment/time_table' ||
              _vm.$route.path == '/home/book_appointment/summary' ||
              _vm.$route.path == '/home/book_appointment/note' ||
              _vm.$route.path == '/home/submit-request' ||
              _vm.$route.path == '/home/issuance' ||
              _vm.$route.path == '/home/my-account' ||
              _vm.$route.path == '/home/dashboard' ||
              _vm.$route.path.includes('admin/admin-dashboard-screen') ||
              _vm.$route.path.includes('statement-of-account') ||
              _vm.$route.path.includes('inquiry') ||
              _vm.$route.path.includes('customer-dashboard')
          )?_c('div',{staticClass:"md:w-1/4 ml-2"},[(_vm.role == 'admin')?_c('AdminSidebar'):_c('Sidebar')],1):_vm._e(),_c('div',{staticClass:"w-full"},[_c('router-view')],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }